import { configureStore } from '@reduxjs/toolkit';
import authSlice from './authSlice';
import modelsSlice from './modelsSlice';
import codesSlice from './codesSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    models: modelsSlice,
    codes: codesSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

export default store;
